module.exports = __webpack_public_path__ + "static/0002-e0fea0b35a0c715d90dbc657ebea7f9f.jpg";